import styled from "styled-components";
import { V3IconSettings } from "../Icons";
import { V3CaptionGrey35 } from "./V3CaptionGrey35";

import type { JSX } from "react";

const IconSettingsWithLabelWrapper = styled.div<{ $isActive: boolean; $isDisabled: boolean }>`
    display: flex;
    align-items: center;
    padding: 28px 15px 27px 15px;
    cursor: ${({ $isDisabled }) => (!$isDisabled ? "pointer" : undefined)};
    background: ${({ $isActive, theme }) => ($isActive ? theme.v3.colors.grey96 : undefined)};
    opacity: ${({ $isDisabled }) => ($isDisabled ? "0.35" : undefined)};
    border-bottom: 1px solid rgba(0, 0, 0, 0);

    ${V3CaptionGrey35} {
        font-size: 13px;
        color: ${({ $isActive, theme }) => ($isActive ? theme.v3.colors.blue : null)};
    }

    svg {
        path,
        rect {
            stroke: ${({ $isActive, theme }) => ($isActive ? theme.v3.colors.blue : null)};
        }
    }

    &:hover {
        background: ${({ theme, $isDisabled }) => (!$isDisabled ? theme.v3.colors.grey96 : null)};
        border-bottom: 1px solid ${({ theme }) => theme.v3.colors.grey88};

        ${V3CaptionGrey35} {
            color: ${({ theme, $isDisabled }) => (theme && !$isDisabled ? theme.v3.colors.blue : null)};
        }

        svg {
            path,
            rect {
                stroke: ${({ theme, $isDisabled }) => (theme && !$isDisabled ? theme.v3.colors.blue : null)};
            }
        }
    }

    > div {
        display: inline-flex;

        &:first-child {
            margin-right: 8px;
        }
    }
`;
interface IconWithLabelProps {
    icon?: JSX.Element;
    label?: string;
    isActive: boolean;
    isDisabled?: boolean;
}

export const IconWithLabel = ({ icon = <V3IconSettings />, label = "Settings", isActive, isDisabled }: IconWithLabelProps) => (
    <IconSettingsWithLabelWrapper $isActive={isActive} $isDisabled={!!isDisabled}>
        <div>{icon}</div>
        <div>
            <V3CaptionGrey35>
                <strong>{label}</strong>
            </V3CaptionGrey35>
        </div>
    </IconSettingsWithLabelWrapper>
);
